<script setup>
import RecursiveNav from '@/components/umisis/navigation/RecursiveNav.vue'
import { ScrollArea } from '@/components/ui/scroll-area'
import { useLeftMenuStore } from '@/stores/leftMenuStore.js'
import { storeToRefs } from 'pinia'

// This component expects the main navigation object as a prop
const menuStore = useLeftMenuStore()

// 2. Get the sorted menu reactively
// We use storeToRefs so navigationTree stays reactive
const { sortedMenu: navigationTree } = storeToRefs(menuStore)
</script>

<template>
  <aside class="top-0 left-0 h-max">
    <ScrollArea class="h-full p-4">
      <h2 class="mb-4 text-lg font-semibold tracking-tight">
        Navigate
      </h2>
      <RecursiveNav :items="navigationTree" />
    </ScrollArea>
  </aside>
</template>
